const Tooltip = ({
  tag = 'div',
  isDisabled,
  title,
  container,
  placement,
  label,
  style = {},
  children,
}) => {
  const containerRef = useRef(null)

  useEffect(() => {
    $(containerRef.current).tooltip({ container, placement })
  })

  return React.createElement(
    tag,
    {
      ref: containerRef,
      'data-toggle': 'tooltip',
      'data-original-title': title,
      onFocus: () => $(containerRef.current).tooltip('show'),
      onBlur: () => $(containerRef.current).tooltip('hide'),
      'aria-label': label,
      role: 'button',
      'aria-disabled': isDisabled,
      style,
    },
    children
  )
}

export default Tooltip
